import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";

import * as playerActions from "../../actions/playerActions";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import Modal from "react-responsive-modal";

import SketchPadSimple from "./SketchPadSimple";
//import SketchPadAdvanced from "./SketchPadAdvanced";

//import * as Utils from "../../utils/utils";


let sessionCounter = 0;

const headerHeight = 50;
const footerHeight = 40;

class SketchPadModal extends PureComponent {

	constructor(props) {
		super(props);
		// console.log("Modal Logbook constructor");

		this.state = {
			contentWidth: 0,
			contentHeight: 0,
			toggleScroll: false,
			sketchPadCounter: ++sessionCounter
		};
		this._measureComponent = this._measureComponent.bind(this);
	}

	componentDidMount() {
		this._measureComponent();
	}

	_measureComponent(force = false) {
		/*
		const self = this;
		
		setTimeout(() => {
		//	let width = self.props.dimensions.width;
		//	let height = self.props.dimensions.height;
			let safeAreaInsets = {}; //self.props.dimensions.safeAreaInsets;
			self._mainView.measure((fx, fy, width, height, x, y) => {

				let effectiveWidth = width - safeAreaInsets.left - safeAreaInsets.right;
				let effectiveHeight = height - headerHeight - footerHeight - safeAreaInsets.top - safeAreaInsets.bottom;
				// console.log("Captured dimensions", width, height);

				if ((self.state.contentWidth === 0 && self.state.contentHeight === 0) || force) {
					// console.log("Testing sktechPadDimensions", self.props.item.sketchPadDimensions);
					if (self.props.item && self.props.item.sketchPadDimensions && self.props.item.sketchPadDimensions.width && self.props.item.sketchPadDimensions.height) {
						effectiveWidth = self.props.item.sketchPadDimensions.width;
						effectiveHeight = self.props.item.sketchPadDimensions.height;
					}
					// console.log("Resizing component to ", effectiveWidth, effectiveHeight);
					self.setState({ contentWidth: effectiveWidth, contentHeight: effectiveHeight });
				}
			});
		});
		*/

	}
	handleToggleScroll() {
		const currentToggleScroll = this.state.toggleScroll;
		this.setState({
			toggleScroll: !currentToggleScroll
		});
	}

	render() {
		let safeAreaInsets = {};//this.props.dimensions.safeAreaInsets;
		if (this.props.item === null || _.isUndefined(this.props.item)) {
			// console.error("NO ITEM!!!");
			return (
				<div />
			);
		}

		// console.log("Initializing modal with dimensions ", this.state.contentWidth, this.state.contentHeight, this.state.sketchPadCounter);
		return (
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-comments-modal",
				transitionEnter: "ambifi-web-player-modal-slide-up-enter",
				transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
				transitionExit: "ambifi-web-player-modal-slide-up-exit",
				transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
			}}
				open={this.props.isOpen}
				showCloseIcon={false}
				onEntered={this.onModalEntered}
				onClose={() => { }}>			
				<div ref={(c) => this._mainView = c} style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", marginTop: 0, marginLeft: 0, marginBottom: 0, marginRight: 0, alignItems: "center", justifyContent: "space-between", backgroundColor: "#121212" }} onLayout={() => { this._measureComponent(); }}>
					<div style={{ display: "flex", flexDirection: "column", flex: 1, marginLeft: safeAreaInsets.left, marginTop: safeAreaInsets.top, marginBottom: safeAreaInsets.bottom, marginRight: safeAreaInsets.right, alignItems: "center", justifyContent: "space-between", width: "100%", height: "100%" }}>
						<div ref={(c) => this._header = c} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: headerHeight, marginTop: 5}}>
							<span style={{ fontSize: 24, color: "white" }}>Sketch Pad</span>
						</div>
						<div style={{ backgroundColor: "lightgray", flex: 1, alignItems: "center", justifyContent: "center", width: "100%", height: "100%", boxSizing: "border-box" }}>
							{<SketchPadSimple key={`sketch-pad-${this.state.sketchPadCounter}`} onClear={this.handleOnClear} onToggleScroll={this.handleToggleScroll.bind(this)} touchEnabled={!this.state.toggleScroll} item={this.props.item} backgroundColor={this.props.item.sketchPadBackgroundColor} penColor={this.props.item.sketchPadPenColor} penWidth={this.props.item.sketchPadPenWidth} />}
						</div>
						<div ref={(c) => this._goBackButton = c} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: footerHeight, marginBottom: 5}}>
							<div style={{ cursor: "pointer" }} onClick={() => { this.props.dispatch((tree) => playerActions.hideSketchPad(tree)); }}>
								<span style={{ fontSize: 20, color: "white" }}><FontAwesomeIcon icon={"chevron-down"} style={{ marginLeft: 10, size: 20 }} /> GO BACK</span>
							</div>
						</div>
					</div>
				</div >
			</Modal>
		);
	}
}

export default branch({
}, SketchPadModal);

